export default __webpack_public_path__ + "static/media/pEGFR.e152beff.png";